// frontend/src/Components/UI/Loader.jsx
import "./Loader.css";

const SIZE_MAP = { small: 24, medium: 40, large: 56 };

const Loader = ({ size = 40, text }) => {
  const px = typeof size === "string" ? (SIZE_MAP[size] ?? 40) : size;

  return (
    <div className="loader-wrapper">
      <div
        className="loader"
        style={{ width: px, height: px }}
        role="status"
        aria-label={text || "Chargement…"}
      />
      {text && <p className="loader-text">{text}</p>}
    </div>
  );
};

export default Loader;
